import { layoutSmall } from 'core/util/default'
import React, { FormEvent } from 'react'
import styled, { css } from 'styled-components'

interface PageHeaderProps {
  message?: string
  border?: boolean
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void
  children: React.ReactNode
  id?: string
}

const PageHeader: React.FC<PageHeaderProps> = (props) => {
  const { border, message, children, onSubmit, id } = props
  return (
    <StyledPageHeader border={border} onSubmit={onSubmit} id={id}>
      {children}
      <div className="header_message" {...(message && { tabIndex: 0 })}>
        {message}
      </div>
    </StyledPageHeader>
  )
}

const StyledPageHeader = styled.form<{ border?: boolean }>`
  height: 50px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;

  .header_message {
    position: absolute;
    left: 0;
    right: 0;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: ${(props) => props.theme.font.primary};
  }

  ${(props) =>
    props.border &&
    css`
      border-bottom: 1px solid ${props.theme.thumbnailLineColor};
    `}

  ${layoutSmall(css`
    padding: 0 16px;
  `)}
`
export default PageHeader
